import styled from "styled-components";
import { FONT_SIZE, BUTTON_HEIGHT } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";

export const FilterCellWrapper = styled.div<{ $displaySize?: string }>`
  .filter-wrapper {
    padding: 10px;
    border: 1px solid;
    width: 260px;
    min-height: 0px !important ;
    max-height: ${({ $displaySize }) =>
      $displaySize?.includes(DISPLAY_SIZES.LARGE)
        ? "calc(100vh - 300px)"
        : $displaySize?.includes(DISPLAY_SIZES.MEDIUM)
        ? "calc(100vh - 280px)"
        : "calc(100vh - 260px)"};
    overflow-y: auto;
    overflow-x: auto;
    box-sizing: border-box;

    /* Hide default scrollbar */
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }

    .ant-form-item {
      margin: 0 0 15px;
    }

    .ant-input {
      max-width: 100%;
      box-sizing: border-box;
      font-size: ${({ $displaySize }) =>
        FONT_SIZE[
          ($displaySize || DISPLAY_SIZES.SMALL) as keyof typeof FONT_SIZE
        ]} !important;
    }

    .title {
      font-size: ${({ $displaySize }) =>
        FONT_SIZE[
          ($displaySize || DISPLAY_SIZES.SMALL) as keyof typeof FONT_SIZE
        ]} !important;
      font-weight: 500;
      margin-bottom: 10px;
    }

    .sort {
      .ant-radio-group {
        display: flex;
        flex-direction: column;
      }

      .ant-radio-wrapper {
        margin: 0;
        padding: 0;
        margin-bottom: 4px;
      }
    }

    .filter {
      border-top: 1px solid #ccc;

      .title {
        margin-top: 10px;
      }

      &-options {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 228px;
        box-sizing: border-box;

        &.scroll {
          overflow-y: scroll;

          /* Hide default scrollbar */
          scrollbar-width: none;
          -ms-overflow-style: none;

          &::-webkit-scrollbar {
            display: none;
          }
        }
      }
    }

    .ant-checkbox-wrapper {
      margin: 0;
      padding: 0;
      margin-bottom: 2px;
      width: 100%;
      max-width: 228px;
      box-sizing: border-box;
      font-size: ${({ $displaySize }) =>
        FONT_SIZE[
          ($displaySize || DISPLAY_SIZES.SMALL) as keyof typeof FONT_SIZE
        ]} !important;
    }

    .ant-checkbox + span {
      font-size: ${({ $displaySize }) =>
        FONT_SIZE[
          ($displaySize || DISPLAY_SIZES.SMALL) as keyof typeof FONT_SIZE
        ]} !important;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .ant-radio-wrapper span {
      font-size: ${({ $displaySize }) =>
        FONT_SIZE[
          ($displaySize || DISPLAY_SIZES.SMALL) as keyof typeof FONT_SIZE
        ]} !important;
    }

    .ant-checkbox-group {
      padding-bottom: 10px;
    }

    .ant-tree {
      font-size: ${({ $displaySize }) =>
        FONT_SIZE[
          ($displaySize || DISPLAY_SIZES.SMALL) as keyof typeof FONT_SIZE
        ]} !important;

      .ant-tree-node-content-wrapper,
      .ant-tree-title {
        font-size: ${({ $displaySize }) =>
          FONT_SIZE[
            ($displaySize || DISPLAY_SIZES.SMALL) as keyof typeof FONT_SIZE
          ]} !important;
      }
    }

    .action {
      display: flex;
      flex-direction: row;
      gap: 5px;

      p {
        font-size: ${({ $displaySize }) =>
          FONT_SIZE[
            ($displaySize || DISPLAY_SIZES.SMALL) as keyof typeof FONT_SIZE
          ]} !important;
        font-weight: 500;
        text-decoration: underline;
        color: #0989ff;
        cursor: pointer;
      }

      span {
        color: #0989ff;
        font-size: ${({ $displaySize }) =>
          FONT_SIZE[
            ($displaySize || DISPLAY_SIZES.SMALL) as keyof typeof FONT_SIZE
          ]} !important;
      }
    }

    .footer {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 20px;
      gap: 10px;

      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 120px;
        min-width: fit-content;
        border-radius: 8px;
        height: ${({ $displaySize }) =>
          BUTTON_HEIGHT[
            ($displaySize || DISPLAY_SIZES.SMALL) as keyof typeof BUTTON_HEIGHT
          ]} !important;
        font-size: ${({ $displaySize }) =>
          FONT_SIZE[
            ($displaySize || DISPLAY_SIZES.SMALL) as keyof typeof FONT_SIZE
          ]} !important;

        &-filter {
          background-color: #174a83;
          color: #ffffff;
          border: 1px solid #174a83;
          border-radius: 8px;
        }

        &-cancel {
          background: #ffffff;
          border: 1px solid #174a83;
          color: #174a83;
          border-radius: 8px;
        }
      }
    }
  }
`;

export const FilterSection = styled.div`
  margin-bottom: 10px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const FilterTitle = styled.p`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 10px;
`;

export const FilterDivider = styled.hr`
  margin-bottom: 10px;
  margin-top: -10px;
  border: none;
  border-top: 1px solid #d9d9d9;
`;

export const FilterOptionsContainer = styled.div<{ $height?: number }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 228px;
  box-sizing: border-box;
  height: ${(props) => (props.$height ? `${props.$height}px` : "auto")};
`;

export const FilterOptionItem = styled.div`
  width: 100%;
  max-width: 228px;
`;

export const EmptyFilterText = styled.p`
  opacity: 0.5;
`;

export const CheckboxGroupWrapper = styled.div`
  width: 100%;
`;

export const ScrollBarContainer = styled.div<{
  $position: "vertical" | "horizontal";
}>`
  ${(props) =>
    props.$position === "vertical"
      ? `
    position: relative;
    display: flex;
  `
      : `
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  `}
  z-index: 10;
  pointer-events: none;
`;

export const ScrollBarInner = styled.div`
  pointer-events: auto;
`;

export const FilterOptionsWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
`;

export const FilterActions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin-top: 10px;
  margin-bottom: 10px;

  span {
    font-size: 14px;
    font-weight: 500;
    text-decoration: underline;
    color: #0989ff;
    cursor: pointer;
  }

  span:nth-child(2) {
    color: #0989ff;
  }
`;

export const FilterFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
  gap: 10px;

  .ant-btn {
    width: 120px;
    min-width: fit-content;
    border-radius: 8px;
  }

  .ant-btn-primary {
    background-color: #174a83;
    color: #ffffff;
    border: 1px solid #174a83;
    border-radius: 8px;

    &:hover {
      background-color: #1e5a9e;
      border-color: #1e5a9e;
    }
  }

  .ant-btn-default {
    background: #ffffff;
    border: 1px solid #174a83;
    color: #174a83;
    border-radius: 8px;

    &:hover {
      border-color: #1e5a9e;
      color: #1e5a9e;
    }
  }
`;
